import { LoaderCircle, SearchX } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

export function LoadingState({ label = 'Loading...' }: { label?: string }) {
  return (
    <div className="flex min-h-64 flex-col items-center justify-center gap-3 text-sm text-muted-foreground animate-pulse">
      <div className="relative flex size-10 items-center justify-center">
        <LoaderCircle className="size-8 animate-spin text-primary" />
        <span className="absolute size-2 rounded-full bg-secondary animate-ping" />
      </div>
      <p className="font-medium tracking-wide text-xs uppercase text-muted-foreground/80 mt-2">{label}</p>
    </div>
  )
}

export function EmptyState({ title = 'Nothing here yet', description = 'Create the first record to get started.' }: { title?: string; description?: string }) {
  return (
    <Card className="border border-dashed border-border/70 shadow-none bg-muted/5">
      <CardContent className="flex min-h-56 flex-col items-center justify-center p-8 text-center">
        <div className="rounded-2xl bg-accent p-4 text-accent-foreground mb-4">
          <SearchX className="size-8 text-primary" />
        </div>
        <p className="font-bold text-foreground text-base tracking-tight">{title}</p>
        <p className="mt-1.5 max-w-sm text-sm text-muted-foreground leading-relaxed">{description}</p>
      </CardContent>
    </Card>
  )
}

export function ErrorState({ error }: { error: unknown }) {
  return (
    <div className="rounded-2xl border border-destructive/20 bg-destructive/5 p-5 text-sm text-destructive shadow-sm shadow-destructive/5 animate-in fade-in-50 duration-200">
      <div className="flex items-start gap-3">
        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-destructive/10 text-xs font-bold font-mono">!</span>
        <div>
          <p className="font-bold text-destructive">Operational Error</p>
          <p className="mt-1 text-xs opacity-90 leading-relaxed">
            {error instanceof Error ? error.message : 'An unexpected exception occurred. Please try reloading or check server status.'}
          </p>
        </div>
      </div>
    </div>
  )
}
